const SafetyRegulationsPart2 = () => {
  return (
    <>
      <h2>Tyverisikring</h2>
      <ul>
        <li>Bilen skal være lukket og låst når det ikke er personer i den.</li>
        <li>
          I forbindelse med salg av bilen skal eieren, eller en han/hun har
          bemyndiget til å bistå med salget, være på/i denne så lenge
          tenningsnøkkel befinner seg der.
        </li>
        <li>
          Deler av bilen som midlertidig er avmontert, skal være innelåst.
        </li>
        <li>
          Ekstra dekk og felger skal være innelåst. I fellesgarasje skal ekstra
          dekk og felger være fastlåst til bygning.
        </li>
        <li>
          Fastmontert utstyr skal være montert slik at det ikke kan fjernes uten
          bruk av verktøy eller nøkkel.
        </li>
        <li>
          Radio-/musikkanlegg skal være fastmontert eller montert i
          tyverikassett.
        </li>
        <li>Skiboks, sykkel- eller skistativ skal være fastmontert og låst.</li>
        <li>
          Om natten, i tiden fra man setter bilen fra seg om kvelden, til man
          tar den i bruk igjen – og i alle tilfeller i tiden mellom klokken
          00.00 og 06.00, skal bagasje ikke befinne seg på bilens tak.
        </li>
        <li>
          Løsøre som etterlates i bil, skal oppbevares i separat, låst
          bagasjerom eller tilsvarende rom uten innsynsmulighet.
        </li>
      </ul>
    </>
  );
};

export default SafetyRegulationsPart2;
